import { useToast } from "@breakout/ui/components/Toast"
import { type NavigateOptions, type RegisteredRouter, useNavigate } from "@tanstack/react-router"
import { useCallback } from "react"

export function useTabNavigation() {
	const navigate = useNavigate()
	const { showToast } = useToast()

	const navigateWithToast = useCallback(
		(options: NavigateOptions<RegisteredRouter, string, string>) => {
			navigate(options).catch((error: unknown) => {
				console.error("[Navigation error]", error)
				showToast("Navigation failed. Please try again.", "error")
			})
		},
		[navigate, showToast],
	)

	return { navigate, navigateWithToast }
}
